import {
  OrderTicketEntity,
  OrderTicketDetailEntity,
} from "@goodfill/domain-entities";
import {
  asOrderTicketId,
  asAccountId,
  asBalanceAccountId,
  asCorporateBondId,
  asBondPriceNominal,
  asAmount,
  asTradeTicketId,
} from "@goodfill/domain-properties";
import Decimal from "decimal.js";
import { OrderTicket, TimeInForce } from "../API";
import { balanceAccountApiToModel } from "../balanceAccount/BalanceAccount";
import { createDateTimeFromAwsDateTime } from "../date/awsDateTimeFormat";
import { createFiniteDecimalFromAnyString } from "../decimal/createFiniteDecimalFromAnyString";

export function orderTicketApiToModel(
  apiOrder: OrderTicket
): OrderTicketEntity {
  return {
    id: asOrderTicketId(apiOrder.id),
    accountId: asAccountId(apiOrder.accountId),
    balanceAccountId: asBalanceAccountId(apiOrder.balanceAccountId),
    bondId: asCorporateBondId(apiOrder.bondId),
    bondPrice: asBondPriceNominal(new Decimal(apiOrder.bondPrice)),
    faceAmount: asAmount(new Decimal(apiOrder.faceAmount)),
    minimumFillSize: new Decimal(apiOrder.minimumFillSize),
    direction: apiOrder.direction,
    status: apiOrder.status,
    isConfirmed: apiOrder.isConfirmed,
    confirmedAt:
      apiOrder.confirmedAt !== null && apiOrder.confirmedAt !== undefined
        ? createDateTimeFromAwsDateTime(apiOrder.confirmedAt, "confirmedAt")
        : null,
    isImmediate:
      apiOrder.isImmediate !== null && apiOrder.isImmediate !== undefined
        ? apiOrder.isImmediate
        : apiOrder.timeInForce === TimeInForce.Immediate,
    timeInForce:
      apiOrder.timeInForce !== null && apiOrder.timeInForce !== undefined
        ? apiOrder.timeInForce
        : null,
    createdAt: createDateTimeFromAwsDateTime(apiOrder.createdAt, "createdAt"),
    expiresAt: createDateTimeFromAwsDateTime(apiOrder.expiresAt, "expiresAt"),
    closingTradeTicketId:
      apiOrder.closingTradeTicketId !== null &&
      apiOrder.closingTradeTicketId !== undefined
        ? asTradeTicketId(apiOrder.closingTradeTicketId)
        : null,
  };
}

export function orderTicketDetailApiToModel(
  apiOrder: OrderTicket
): OrderTicketDetailEntity {
  const apiAppliedCommission = apiOrder.appliedCommissionRate ?? null;

  if (apiAppliedCommission === null) {
    throw new Error(`Missing applied commision fo ticket ${apiOrder.id}`);
  }

  const appliedCommissionRate = createFiniteDecimalFromAnyString(
    apiAppliedCommission.rate,
    "appliedCommissionRate.rate"
  );

  const appliedCommissionAmount = createFiniteDecimalFromAnyString(
    apiAppliedCommission.amount,
    "appliedCommissionRate.amount"
  );

  return {
    ...orderTicketApiToModel(apiOrder),
    balanceAccount: balanceAccountApiToModel(apiOrder.balanceAccount),
    appliedCommission: {
      rate: appliedCommissionRate,
      amount: asAmount(appliedCommissionAmount),
    },
  };
}
